/* 🤖 this file was generated by svg-to-ts */
export const matIconCameraOutdoor: {
  name: 'camera-outdoor';
  data: string;
} = {
  name: 'camera-outdoor',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M18 13c0-.55-.45-1-1-1h-4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-1l2 1.06v-4.12L18 14v-1zM12 3 4 9v12h16v-2H6v-9l6-4.5 6 4.5v1h2V9l-8-6z"/></svg>`
};
